import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { take, tap } from 'rxjs';

import { AppFacade } from '@shared/state/facades';
import { CacheService, SignalRService, ZendeskService } from '.';
import { AuthService } from '@auth/services';
import { SortDirection } from '@shared/enums';

@UntilDestroy()
@Injectable()
export class SignOutService {
  private isAppOnlineRealState$ = this.appFacade.query.isAppOnlineRealState$;
  constructor(
    private appFacade: AppFacade,
    private signalRService: SignalRService,
    private authService: AuthService,
    private cacheService: CacheService,
    private zendeskService: ZendeskService
  ) {}

  signOut(): void {
    this.isAppOnlineRealState$
      .pipe(
        untilDestroyed(this),
        take(1),
        tap(async (isAppOnlineRealState) => {
          if (isAppOnlineRealState) {
            this.signalRService.disconnect();

            this.clearSession();
            await this.authService.signoutRedirect();
          } else {
            this.clearSession();
            window.location.href = '/';
          }
        })
      )
      .subscribe();
  }

  get isSigningOut(): boolean {
    return this.authService.isSigningOutState;
  }

  //#region Private methods

  private clearSession(): void {
    this.zendeskService.logoutUser();
    this.cacheService.cleanCache();
    this.appFacade.setAppLockedInOffline(false);
    this.appFacade.setDprsSortingDirection(SortDirection.Descending);
  }

  //#endregion
}
